/**
 * @author Oguntuberu Nathan O. <nateoguns.work@gmail.com>
 */
import DateUtils from 'src/app/utils/date';

class PaymentFilter {
    private date_utility = new DateUtils();

    public default_filters: any = {
        amountPaid: {
            min: 0,
            max: 0
        },
        createdOn: {
            min: '',
            max: ''
        }
    };

    public selected_filters: any = { ...this.default_filters };
    public custom_filters: any = {};

    constructor() { }

    /**
     * Build query string from filter selection
     * 
     * @returns a formatted query string 
     */
    build_query_string() {
        let range = {};
        if (!Object.keys(this.selected_filters).length) return '';
        for (let key in this.selected_filters) {
            if (typeof this.selected_filters[key] == "string" || typeof this.selected_filters[key] == "number") {

                return;
            }

            range[key] = {
                from: this.selected_filters[key].min || 0,
                to: this.selected_filters[key].max || 999999999999999,
            }
        }

        return `range=${JSON.stringify(range)}`;
    }

    /**
     * Reset filter selections
     */
    clear_filters() {
        this.selected_filters = { ...this.default_filters };
        this.selected_filters.amountPaid = {
            min: 0,
            max: 0
        };
        this.selected_filters.createdOn = {
            min: '',
            max: ''
        };
    }

    /**
     * Make selections on simple key => value filter keys
     * 
     * @param filter_field The filter key
     * @param value   The provided value
     */
    make_single_selection(filter_field: string, value: any) {
        this.selected_filters[filter_field] = value;
    }

    /**
     * Make a range selection
     * 
     * @param filter_field The field to filter by
     * @param value  {number} The value to set
     * @param is_min {boolean} Set to true if it is minimum range value. False if it is the maximum range value
     */
    make_range_selection(filter_field: string, value: number, is_min = true) {
        const position = is_min ? 'min' : 'max';
        if (filter_field == 'createdOn') {
            this.selected_filters[filter_field][position] = this.date_utility.convertDateStringToTimestamp(value);
        } else {
            this.selected_filters[filter_field][position] = Number(value);
        }
    }
}

export default PaymentFilter;